module.exports = __webpack_public_path__ + "img/student_3.b4fe4c9d.png";